<template>
  <div class="search-btn">
    <div class="search-btn__label" v-on:click="onSearch"></div>
  </div>
</template>
<script>
  export default {
    name: 'SearchBtn',
    methods: {
      onSearch() {
        this.$emit('goToSearch', 'search');
      },
    },
  }
</script>
